enum POSITIONS {
  DEFAULT = 'DEFAULT',
  TOP = 'TOP',
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  BOTTOM = 'BOTTOM',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
}

export default POSITIONS
